(function () {
  const seen = new Set();

  function linkPrefetch(url) {
    if (!url || seen.has(url)) return;
    seen.add(url);

    // 1) Browser prefetch hint
    const l = document.createElement("link");
    l.rel = "prefetch";
    l.href = url;
    l.as = "document";
    document.head.appendChild(l);

    // 2) Also warm HTTP cache (more reliable on mobile)
    try {
      fetch(url, { credentials: "same-origin" }).catch(() => {});
    } catch (e) {}
  }

  function prefetchAllSwatches() {
    document.querySelectorAll('a[data-related-color-link]').forEach((a) => {
      linkPrefetch(a.href);
    });
  }

  // Prefetch everything once the browser is idle
  if ("requestIdleCallback" in window) {
    requestIdleCallback(prefetchAllSwatches, { timeout: 2000 });
  } else {
    setTimeout(prefetchAllSwatches, 800);
  }

  // Also prefetch on hover/touch (extra)
  document.addEventListener("mouseover", (e) => {
    const a = e.target.closest('a[data-related-color-link]');
    if (a) linkPrefetch(a.href);
  });

  document.addEventListener(
    "touchstart",
    (e) => {
      const a = e.target.closest('a[data-related-color-link]');
      if (a) linkPrefetch(a.href);
    },
    { passive: true }
  );
})();
